import React from 'react';
import {
  Document,
  Page,
  Image,
  StyleSheet,
  View,
  Text,
} from '@react-pdf/renderer';

// Define styles with proper aspect ratio handling
const styles = StyleSheet.create({
  page: {
    backgroundColor: '#f0f0f0',
    padding: 0,
  },
  imageContainer: {
    width: '90%',
    height: '90%',
    position: 'absolute',
    top: '5%',
    left: '5%',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  },
  emptyPage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  emptyText: {
    fontSize: 20,
    color: '#666',
  }
});

// Define Props
interface PitchDeckPDFProps {
  images?: string[];
  slides?: { id: string; content: JSX.Element }[];
}

const PitchDeckPDF: React.FC<PitchDeckPDFProps> = ({ images, slides }) => {
  if (images && images.length > 0) {
    return (
      <Document>
        {images.map((imgSrc, index) => (
          <Page 
            key={index} 
            size={[1024, 768]} 
            style={styles.page}
          >
            <View style={styles.imageContainer}>
              <Image 
                src={imgSrc} 
                style={styles.image}
                cache={false}
              />
            </View>
          </Page>
        ))}
      </Document>
    );
  }

  // If no images or slides, return empty document
  if (!slides || slides.length === 0) {
    return (
      <Document>
        <Page size={[1024, 768]} style={styles.page}>
          <View style={styles.emptyPage}>
            <Text style={styles.emptyText}>No content available</Text>
          </View>
        </Page>
      </Document>
    );
  }

  // Return document with slides
  return (
    <Document>
      {slides.map((slide, index) => (
        <Page 
          key={slide.id} 
          size={[1024, 768]} 
          style={styles.page}
        >
          <View style={styles.imageContainer}>
            {/* Note: React elements cannot be directly rendered in PDF.
                You'll need to convert them to images first */}
            <Text style={styles.emptyText}>Slide {index + 1}</Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default PitchDeckPDF;
